<template>
  <div
    :class="{
      'px-standard py-standard': showPadding,
      'flex items-center': isSimpleHeading,
      'space-y-2': !isSimpleHeading,
      'border-b border-neutral-200': showBorder,
    }"
  >
    <div class="flex justify-between">
      <button
        v-if="showClose"
        type="button"
        :aria-label="$t('app.close')"
        @click="$emit('close', $event)"
      >
        <fa
          :icon="['fas', 'xmark']"
          :class="{
            'text-xl': isSimpleHeading,
            'text-lg': !isSimpleHeading,
          }"
          class="hover:opacity-70"
        />
      </button>

      <button
        v-else-if="showBack || showBackTextLink"
        type="button"
        :aria-label="$t('app.back')"
        :class="{ 'text-sm underline underline-offset-2': showBackTextLink }"
        @click.stop="$emit('back', $event)"
      >
        <template v-if="showBackTextLink">
          {{ $t('common.back') }}
        </template>
        <fa
          v-else
          :icon="['fas', 'chevron-left']"
          class="text-lg hover:opacity-70"
        />
      </button>

      <!-- Right optional button-->
      <div class="hover:opacity-70">
        <slot name="right-button" />
      </div>
    </div>

    <slot name="header-content" />

    <div
      v-if="header || subHeader"
      :class="headerSize"
    >
      <div class="flex items-end justify-between space-x-5">
        <h2
          v-if="header"
          class="text-neutral-900"
          :class="{
            'text-3xl font-bold border-l ml-4 pl-2 border-neutral-200 font-title leading-none': isSimpleHeading,
            'text-2xl font-title leading-6 font-medium': !isSimpleHeading,
            [headerClasses]: headerClasses,
          }"
        >
          {{ header }}
        </h2>
        <vetster-outline-badge
          v-if="badge"
          :class="badgeClasses"
          :color="badgeVariant"
        >
          <template #label>
            {{ badge }}
          </template>
        </vetster-outline-badge>
      </div>
      <p
        v-if="subHeader"
        class="mt-2 text-sm font-medium text-neutral-500"
      >
        {{ subHeader }}
      </p>
    </div>

    <slot />
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faChevronLeft,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons';

import VetsterOutlineBadge from '@/brand-components/VetsterOutlineBadge';

library.add({
  faChevronLeft,
  faXmark,
});

export default {
  name: 'VetsterSlideOverCommonHeading',

  components: { VetsterOutlineBadge },

  props: {
    badge: {
      type: String,
      default: undefined,
    },
    badgeClasses: {
      type: String,
      default: '',
    },
    badgeVariant: {
      type: String,
      default: undefined,
    },
    header: {
      type: String,
      default: undefined,
    },
    headerClasses: {
      type: String,
      default: '',
    },
    headerSize: {
      type: String,
      default: undefined,
    },
    isSimpleHeading: {
      type: Boolean,
      default: false,
    },
    subHeader: {
      type: String,
      default: undefined,
    },
    showBack: {
      type: Boolean,
      default: false,
    },
    showBackTextLink: {
      type: Boolean,
      default: false,
    },
    showBorder: {
      type: Boolean,
      default: false,
    },
    showClose: {
      type: Boolean,
      default: true,
    },
    showPadding: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
